// removed by extract-text-webpack-plugin
module.exports = {"loader":"_3gq4U3gC7Fa3BOVczohPBy","circularProgress":"_3nlNPcr1UiDiUinuDsTz4d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Loader.css
// module id = 1190
// module chunks = 0